import { Controller } from '@hotwired/stimulus';

const availableSliderControllers = [];

export default class extends Controller {

    static get targets() {
        return ['slider', 'thumbs'];
    }

    connect() {
        availableSliderControllers.push(this);

        const element = this.element;
        let slider = this.targets.find('slider');
        const useThumbs = this.targets.find('thumbs');
        if (!slider) {
            slider = element;
        }

        if (slider.dataset.splide) {
            Promise.all([
                import('@splidejs/splide'),
                import('@splidejs/splide-extension-auto-scroll'),
                import('@splidejs/splide/css/core'),
            ]).then(([Splide, AutoMod]) => {

                const AutoScroll = AutoMod.AutoScroll || AutoMod.default;

                const additionalConfig = slider.dataset.splide ? JSON.parse(slider.dataset.splide) : {};
                const config = {
                    gap: '0px',
                    ...additionalConfig,
                };
                this.splide = new Splide.default(element, config);
                if (config['autoScroll']) {
                    this.splide.mount({ AutoScroll });
                } else {
                    this.splide.mount();
                }

                if (element.dataset.sync) {
                    for (const controller of availableSliderControllers) {
                        if (controller.element.id === element.dataset.sync) {
                            this.splide.sync(controller.splide);
                        }
                    }
                }

                if ('clickFocus' in config) {
                    this.element.querySelectorAll('.splide__slide').forEach((slide, index) => {
                        slide.addEventListener('click', () => {
                            this.splide.go(index); // Set the clicked slide as active
                        });
                    });
                }
            });
        }
    }
}
